import { api } from './client';

export type TargetType = 'static' | 'proxy';

export interface SubdomainEntry {
  domain: string;
  target_type: TargetType;
  target: string;
  ssl: boolean;
  created_at: string;
}

export interface SubdomainConfig {
  primary_domain: string;
  root_domain: string;
  certbot_email: string;
  subdomains: SubdomainEntry[];
}

export interface AddSubdomainPayload {
  domain: string;
  target_type: TargetType;
  target?: string;
}

export const fetchSubdomains = (): Promise<SubdomainConfig> =>
  api.get<SubdomainConfig>('/subdomains').then((r) => r.data);

export const addSubdomain = (payload: AddSubdomainPayload): Promise<SubdomainEntry> =>
  api.post<SubdomainEntry>('/subdomains', payload).then((r) => r.data);

export const removeSubdomain = (domain: string): Promise<void> =>
  api.delete(`/subdomains/${domain}`).then(() => undefined);

export const requestCert = (domain: string): Promise<void> =>
  api.post(`/subdomains/${domain}/cert`).then(() => undefined);
